import { useLocation, useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { GitCompare, X, ArrowRight } from "lucide-react";
import { useCompare } from "@/context/CompareContext";

export default function CompareBar() {
  const compare = useCompare();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (!compare) return null;
  const { ids, clear, remove } = compare;
  // Hide on the compare page itself and on admin/auth screens.
  if (pathname.startsWith("/compare") || pathname.startsWith("/admin") ||
      pathname === "/login" || pathname === "/register") return null;

  const show = ids.length >= 2;

  return (
    <AnimatePresence>
      {show && (
        <motion.div initial={{ y: 80, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 80, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 28 }}
          className="fixed bottom-5 left-1/2 -translate-x-1/2 z-[90] w-[calc(100%-2rem)] max-w-lg"
          data-testid="compare-bar">
          <div className="rounded-2xl bg-[#111827] text-white shadow-2xl border border-white/10 px-4 py-3 flex items-center gap-3">
            <div className="flex items-center gap-2 text-sm font-semibold">
              <GitCompare size={18} className="text-[#2A9D8F]" />
              <span data-testid="compare-count">{ids.length} selected</span>
            </div>
            <div className="hidden sm:flex items-center gap-1.5 flex-1 min-w-0">
              {ids.map((id) => (
                <button key={id} onClick={() => remove(id)}
                  className="inline-flex items-center gap-1 rounded-full bg-white/10 hover:bg-white/20 px-2 py-1 text-[11px] font-mono truncate max-w-[110px]"
                  title="Remove" data-testid={`compare-chip-${id}`}>
                  {id.replace("prov-", "")} <X size={11} />
                </button>
              ))}
            </div>
            <button onClick={clear} className="ml-auto text-xs text-white/60 hover:text-white" data-testid="compare-clear">Clear</button>
            <button onClick={() => navigate(`/compare?ids=${ids.join(",")}`)} data-testid="compare-go-btn"
              className="inline-flex items-center gap-1.5 rounded-full bg-[#2A9D8F] hover:bg-[#238377] px-4 py-2 text-sm font-semibold">
              Compare ({ids.length}) <ArrowRight size={15} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
